import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from 'modules/common/hooks/useAuth';
import { FC } from 'react';

export const PublicOutlet: FC = () => {
  const auth = useAuth();
  return auth ? <Navigate to="/" /> : <Outlet />;
};
